import type { MapStateToPropsFactory } from 'react-redux';
import { connect } from 'react-redux';
import type { CpOrderStatus } from 'state/secondaryMarket/cpOrder/order/order.model';
import { fromSecondaryMarket } from 'state/selectors';
import type { AppState } from 'state/state.model';

type OwnProps = Readonly<{
  tabId: string;
}>;

type StateProps = Readonly<{
  status: CpOrderStatus;
}>;

export type SidePanelProps = OwnProps & StateProps;

const mapStateToProps: MapStateToPropsFactory<StateProps, OwnProps, AppState> = () => {
  const getCpOrderValidationErrors = fromSecondaryMarket.cpOrder.form.makeGetCpOrderValidationErrors();

  const getCpOrderStatus = fromSecondaryMarket.cpOrder.order.makeGetCpOrderStatus(getCpOrderValidationErrors);

  return (state, { tabId }) => {
    const status = getCpOrderStatus(state, tabId);
    return {
      status,
    };
  };
};

export const connectSidePanel = connect(mapStateToProps);
